import * as React from "react";
import {RestDataLoader} from "../../dashboard/widgets/unilever/RestDataLoader";
import {Activity, ActivityParams} from "../user-details-sections/UserActivities";
import {useUserDetails} from "./UserDetailsContext";

export type UserActivities = [
    Activity[],
    boolean,
    () => void
]


export type activityResponse = {
    id: number,
    user: string,
    activityDate: string,
    activityText: string,
    activityNotes: string,
    actionGuid: string,
    param: string
}

const UserActivitiesContext = React.createContext<UserActivities>({} as any);

export const UserActivitiesProvider: React.FC = ({children}) => {
    const [activities, setUserActivities] = React.useState<Activity[]>([]);
    const [isLoading, setIsLoading] = React.useState<boolean>(true);
    const [currentUser] = useUserDetails();

    const updateUserActivities = () => {
        setIsLoading(true);
        if (currentUser) {
            getUserActivities(currentUser.guid)
                .then((data) => {
                    setUserActivities(data);
                    setIsLoading(false);
                })
                .catch(console.error);
        }
    }

    React.useEffect(() => {
        updateUserActivities();
    }, [currentUser]);

    React.useEffect(() => {
        if (activities.length === 0) {
            updateUserActivities();
        }
    }, []);

    return (
        <UserActivitiesContext.Provider value={[activities, isLoading, updateUserActivities]}>
            {children}
        </UserActivitiesContext.Provider>
    )
}

const parseParam = (param: string): ActivityParams => {
    const p: ActivityParams = JSON.parse(param);
    return {
        field: p?.field,
        oldValue: (p?.oldValue as string)?.split(','),
        newValue: (p?.newValue as string)?.split(','),
        translationKey: p?.translationKey
    }
}
const mapActivitiesParams = (data: activityResponse[]): Activity[] => {
    return data.map((act) => {
        return {
            actionGuid: act.actionGuid,
            activityDate: act.activityDate,
            activityNotes: act.activityNotes,
            activityText: act.activityText,
            user: act.user,
            id: act.id,
            param: parseParam(act.param)
        }
    })
}

function getUserActivities(guid: string) {
    return new Promise<Activity[]>((res, rej) => {
        RestDataLoader.loadData(
            "users/" + guid + "/activities",
            {},
            (data) => res(mapActivitiesParams(data)),
            () => rej(),
        );
    });
}

export function useUserActivities() {
    return React.useContext(UserActivitiesContext)
}